import React from "react";
import useStore from "../../../../../context/useStore";
import useInsuranceCompanies from "../../../../../hooks/useInsuranceCompanies/useInsuranceCompanies";
import useProducers from "../../../../../hooks/useProducers/useProducers";
import useProducts from "../../../../../hooks/useProducts/useProducts";
import useProductTypes from "../../../../../hooks/useProductTypes/useProductTypes";
import useClientFilters from "./useClientFilters";
import { buildFilterTokens } from "./clientFilterTokens";

// Ligne de résumé : chaque filtre actif devient un jeton retirable ; à droite
// le nombre de résultats et « Tout effacer ». Rien n'est rendu sans filtre.
const ClientActiveFiltersSummary = () => {
  const [state] = useStore();
  const { POLICIES_STATUS, ACCOUNT_STATUS } = state.constants.items;
  const { insuranceCompanies } = useInsuranceCompanies();
  const { productTypes } = useProductTypes();
  const { products } = useProducts();
  const { producers } = useProducers();
  const { filtres, actions, isListInit, resultCount } = useClientFilters();

  const tokens = buildFilterTokens(filtres, {
    POLICIES_STATUS,
    ACCOUNT_STATUS,
    insuranceCompanies,
    productTypes,
    products,
    producers,
  });

  if (!tokens.length) return null;

  return (
    <div className="lf-summary">
      <span className="lf-lbl">FILTRES</span>
      {tokens.map((t) => (
        <span key={t.key} className="lf-token">
          <span>{t.label}</span>
          <button
            type="button"
            className="lf-x"
            onClick={() => actions.removeFilterToken(t.clear)}
            aria-label={`Retirer le filtre ${t.label}`}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </span>
      ))}
      <span className="lf-right">
        {isListInit && (
          <span className="lf-count-res" aria-live="polite">
            {resultCount.toLocaleString("fr-FR")} résultat{resultCount > 1 ? "s" : ""}
          </span>
        )}
        <button type="button" className="lf-clear" onClick={actions.clearAllFilters}>
          Tout effacer
        </button>
      </span>
    </div>
  );
};

export default ClientActiveFiltersSummary;
